import template from './swag-migration-profile-shopware6-api-page-information.html.twig';
import './swag-migration-profile-shopware6-api-page-information.scss';

const { Component } = Shopware;

/**
 * @package services-settings
 */
Component.register('swag-migration-profile-shopware6major-api-page-information', {
    template,
});
